import React, { useRef, useState} from 'react';
import { Form, Field } from 'react-final-form';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import { useClient } from "../../../../../Context/ClientContext";
import { InviteUser } from '../../../../../Data/user_service';
import { ContactAdmin } from '../../../navBar';
import { useUser } from '../../../../../Context/UserContext';
import "./AddUser.css";
export const toLowerCase = (value) => (value ? value.toLowerCase() : '');
export const toUpperCase = (value) => (value ? value.toUpperCase() : '');

export const capitalizeFirstLetter = (value) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
export default function AddUser({ setDialogAdd , refetch }) {
    const {selectedClient ,client}=useClient()
    const [errorMessage,setErrorMessage]=useState('')// new state to generate errors
    
    const {user }=useUser()
    const NomClient = Object.values(client).find((cU) => cU.id_client_gexpertise === selectedClient).nom
    
    const toast = useRef(null);
   
    const onSubmit = async (data) => {
       
        InviteUser({
            email: data.email,
            id_client_gexpertise: selectedClient,
            nom: data.nom,
            prenom: data.prenom,
            authorisation: data.authorisation,
            is_gex_memeber: data.is_gex_memeber,
        })
        .then(()=>{
                   toast.current.show({ severity: 'success', summary: 'Succès ', detail: "l'invitation est envoyé avec succès", life: 2000 });
                   
                
           setTimeout(() => {
                    setDialogAdd(false)
                  }, 1000);
                  refetch()
        })
        .catch(()=>  {
            setErrorMessage("Cet utilisateur dispose d'ores et déjà d'un accès à ce compte GexOnline.") ;
         //toast.current.show({ severity: 'error', summary: 'Erreur ', detail: "l'utilisateur existe déja dans la base de données", life: 3000 }))

         setTimeout(() => {
            setErrorMessage('');
        }, 3000);
    })
}

    const validate = (data) => {
        let errors = {};
        if (!data.nom) {
            errors.nom = ' Donnée requise';
        }

        if (!data.prenom) {
            errors.prenom = 'Donnée requise'
        }
        if (!data.email) {
            errors.email = "Donnée requise";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i.test(data.email)
          ) {
            errors.email = "adresse mail invalide";
          }
        if (!data.authorisation) {
            errors.authorisation = 'Donnée requise';
        }

        return errors;
    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };

    return (
        <div className="toolBar_header">
            {errorMessage && (// Affichage conditionnel su message d'erreur 
            <div style={{backgroundColor: '#f8d7da',
                color: '#721c24',
                padding: '10px',
                borderRadius: '5px',
                textAlign: 'center',
                marginBottom: '25px',
                //position: 'absolute', // Position absolue pour coller en haut
                //top: 10, // Aligner au top
                //left: 90,
                //right: 0,
                //zIndex: 0, // Assure que l'erreur reste visible
            }}>{errorMessage}</div>

            )}
        <Toast ref={toast} />
            <Form onSubmit={onSubmit} initialValues={{ nom: '', prenom: '', email: '' , is_gex_memeber:false , authorisation: false}} validate={validate} render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="p-fluid">
                    <Field 
                    format={toUpperCase} parse={toUpperCase}
                    name="nom" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">
                                <InputText id="nom" 
                                 {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                 
                                  />
                                <label htmlFor="nom" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Nom  *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />

                    <Field name="prenom" 
                    format={capitalizeFirstLetter} 
                                     parse={capitalizeFirstLetter}
                    render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputText id="prenom" {...input} 
                                  
                                 className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="prenom" className={classNames({ 'p-error': isFormFieldValid(meta) })}>prenom *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />

                    <Field 
                    format={toLowerCase} parse={toLowerCase}
                     name="email" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputText id="emails" {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Adresse mail *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                 { ContactAdmin(user) &&  <div className="field-checkbox">
                       
                        <Field name="is_gex_memeber" type="checkbox" 
                       >
                            {({ input, meta }) => (
                                <div style={{display:"flex", flexDirection:"row"}}>
                               
                                    <input {...input} id="is_gex_memeber"   hidden={selectedClient !=="1"}/>
                                    <label htmlFor="is_gex_memeber"  hidden={selectedClient !=="1"}>
                                    membre de Gexpertise
                                    </label>
                                  
                                </div>
                            )}
                        </Field>
                        <label htmlFor="binary"> </label>
                        </div>}
                    <div className="field-checkbox">
                       
                        <Field name="authorisation" type="checkbox">
                            {({ input, meta }) => (
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <input {...input} id="authorisation" style={{ marginRight:"1%"}}/>
                                    <label htmlFor="authorisation" className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                    J’autorise cet utilisateur à avoir accès à l’ensemble des actifs et livrables disponibles sur GexOnline pour  « {NomClient} »<span style={{color:"#970121"}}> * </span>
                                    <br/>
                                    <div> {getFormErrorMessage(meta)}</div>
                                    </label>
                                     
                                 
                                </div>
                                 
                            )}
                        </Field>
                        <label htmlFor="binary"> </label>
                    </div>
                    <div className='btnContact'>
                     
                        <Button type="submit" label="Envoyer l'invitation" className="p-mt-2 send" />
                    </div>

                </form>
            )} />
        </div>
    )
}